var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabletTouch = function SvgTabletTouch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 58.125L32.0525 52.265C31.4401 51.7755 30.9811 51.1204 30.7303 50.3776C30.4794 49.6348 30.4472 48.8356 30.6375 48.075V48.075C30.7861 47.4802 31.0664 46.9264 31.4578 46.4545C31.8491 45.9826 32.3415 45.6047 32.8985 45.3486C33.4555 45.0926 34.063 44.9649 34.6759 44.9751C35.2889 44.9853 35.8918 45.1331 36.44 45.4075L39.375 46.875V33.75C39.375 32.7554 39.7701 31.8016 40.4733 31.0983C41.1766 30.3951 42.1304 30 43.125 30C44.1195 30 45.0734 30.3951 45.7766 31.0983C46.4799 31.8016 46.875 32.7554 46.875 33.75V41.25L51.8575 42.08C53.6087 42.3718 55.1996 43.2753 56.3473 44.6298C57.4949 45.9844 58.1248 47.7021 58.125 49.4775V58.125",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86768 43.125H24.3752",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 54.375H5.625C4.63044 54.375 3.67661 53.9799 2.97335 53.2766C2.27009 52.5734 1.875 51.6196 1.875 50.625V5.625C1.875 4.63044 2.27009 3.67661 2.97335 2.97335C3.67661 2.27009 4.63044 1.875 5.625 1.875H35.625C36.6196 1.875 37.5734 2.27009 38.2767 2.97335C38.9799 3.67661 39.375 4.63044 39.375 5.625V22.5",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5349 29.3603C16.0759 30.0719 16.7807 30.6423 17.5894 31.0232C18.3981 31.404 19.2868 31.584 20.1799 31.5478C23.0274 31.5478 25.3374 29.8153 25.3374 27.6803C25.3374 25.5453 23.0274 23.8153 20.1799 23.8153C17.3324 23.8153 15.0249 22.0828 15.0249 19.9453C15.0249 17.8078 17.3349 16.0778 20.1799 16.0778C21.073 16.0416 21.9617 16.2216 22.7704 16.6024C23.5791 16.9833 24.2839 17.5537 24.8249 18.2653",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 31.5479V34.1254",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 13.5V16.0775",
    stroke: "#CDD2D8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabletTouch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tablet-touch.7608819c.svg";
export { ForwardRef as ReactComponent };